export const ConsumerPhoneValidationViewUat = {
  titleMessage: 'workflow.consumerPhoneValidation.titleMessage',
  subTitleMessage: 'workflow.consumerPhoneValidation.subTitleMessage',
  disclaimerMessage: 'workflow.consumerPhoneValidation.disclaimerMessage',
}
